module.exports = require("ramda/src/cond");